// muiPossibleRewardsStyles.tsx
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

// --- SectionSubtext
export const SectionSubtext = styled('p')({
  fontFamily: `'SharpSansDisplayNo1-Medium', tahoma, helvetica, arial, sans-serif`,
  fontWeight: 600,
  fontSize: 21,
  marginBottom: 10,
  '@media (max-width: 599px)': {
    fontSize: 18,
  },
});

// --- PossibleRewardsContainer
export const PossibleRewardsContainer = styled(Box)({
  display: 'grid',
  // original used 33% 33% 33%; repeat(3, 1fr) matches typical behavior
  gridTemplateColumns: 'repeat(3, 1fr)',
  justifyContent: 'center',
  margin: '15px auto 0',
  '@media only screen and (max-width: 992px)': {
    display: 'block',
  },
});

// --- PossibleRewardBlock
export const PossibleRewardBlock = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  margin: 0,
  width: 'min-content',
  borderBottom: '1px solid #bbb',
  padding: '10px 10px 20px',
  boxSizing: 'border-box',

  '& > *': {
    minWidth: 130,
    maxWidth: 130,
    margin: '0 auto',
  },

  // &:nth-child(odd) { /* border-right was commented out in original */ }

  '&:last-of-type:nth-child(odd)': {
    borderRight: 'none',
  },

  '@media only screen and (min-width: 992px)': {
    borderBottom: 'none',
    padding: 0,

    '&, &:last-of-type:nth-child(odd)': {
      margin: '30px 0',
    },

    '&:last-of-type, &:nth-child(5)': {
      borderRight: 'none',
    },
  },

  '@media only screen and (max-width: 991px)': {
    width: '100%',
    '& p, & div': {
      margin: 0,
    },
  },
});

// --- PossibleRewardCost
export const PossibleRewardCost = styled('p')({
  display: 'flex',
  alignItems: 'center',
  fontFamily: `'OpenSans-Regular', sans-serif`,
  fontSize: 14,
  lineHeight: 1.43,
  '& img': {
    textAlign: 'left',
    width: 100,
  },
});

// --- PossibleRewardInfo
export const PossibleRewardInfo = styled(Box)({
  boxSizing: 'border-box',
  '& p': {
    fontWeight: 300,
    color: 'rgb(19, 19, 19)',
  },
});

// --- PossibleRewardTitle
export const PossibleRewardTitle = styled('p')({
  fontFamily: `'SharpSansDisplayNo1-Semibold', tahoma, helvetica, arial, sans-serif`,
  fontSize: 18,
  fontWeight: 500,
  lineHeight: 1.22,
  textAlign: 'left',
  color: '#131313',
  marginTop: 10,
  marginBottom: 0,
});

// --- PossibleRewardSubtext
export const PossibleRewardSubtext = styled('p')({
  fontFamily: `'OpenSans-Regular', sans-serif`,
  fontSize: 11,
  margin: 0,
  fontStyle: 'italic',
  whiteSpace: 'nowrap',
  textAlign: 'left',
});
